// extracted by mini-css-extract-plugin
export var arrow = "TeaserList-module--arrow--b654a";
export var body = "TeaserList-module--body--dfe45";
export var subtitle = "TeaserList-module--subtitle--76458";
export var suptitle = "TeaserList-module--suptitle--694f3";
export var title = "TeaserList-module--title--5a1ab";
export var wrapper = "TeaserList-module--wrapper--c3ac7";